export default __webpack_public_path__ + "static/media/greenAnn.cb95c3bb.svg";